import { set_member_reference } from "@cozumel-reef-maps/web_general/js/utils/members_reference.js";
import { buildIosSliderHTML, initIosLightbox } from "@cozumel-reef-maps/web_general/js/ui/slider_images.js";
import { hidde_preloader } from "@cozumel-reef-maps/web_general/js/ui/preloader.js";

import { register } from "@cozumel-reef-maps/web_general/js/api/api.js";
import { store } from "@cozumel-reef-maps/web_general/js/store/store.js";
import { alertas } from "@cozumel-reef-maps/web_general/js/ui/alerts.js";

import { ValidateEmail } from "@cozumel-reef-maps/web_general/js/utils/helpers.js";


// =========================
// INIT FLOW (CORREGIDO)
// =========================


// ==========================================
// FUNCIÓN DE ENTRADA (Manejada por el Router)
// ==========================================
export default async function initRegisterLogin(container) {
    // 1. Ejecutar referencias globales
    set_member_reference();

    // 2. Ejecutar de forma segura lógica de sliders y planes
    view_slider();

    // 3. Ocultar preloader al finalizar la carga
    hidde_preloader();

    const registerBtn = container ? container.querySelector('#button_register') : document.getElementById('button_register');

    if (registerBtn) {
        registerBtn.addEventListener('click', function(event) {
            event.preventDefault(); // Evita el comportamiento por defecto del enlace <a>
            
            console.log('¡Hicieron clic en el botón de registro!');
            
            // Pasamos el container si start_register necesita buscar inputs dentro de él
            start_register(container); 
        });
    } else {
        console.warn('No se encontró el botón con el ID "button_register" en el DOM.');
    }
}





function start_register(container) {
    store.SELECTED_PLAN  = null;
    store.SELECTED_PRICE = 0;

    // Nota: Si usas 'container', podrías cambiar 'document' por 'container' aquí también para mayor seguridad modular
    const context = container || document;

    const email  = context.getElementById("email")?.value || "";
    const nombre = context.getElementById("name")?.value || "";
    const pass1  = context.getElementById("password")?.value || "";
    const pass2  = context.getElementById("repeat_password")?.value || "";

    // Validar términos usando un ID específico para evitar conflictos con otros checkboxes
    const termsCheckbox = context.getElementById("terms_conditions") || context.querySelector('input[type="checkbox"]');
    
    if (!termsCheckbox || !termsCheckbox.checked) {
        alertas({
            type: "error",
            title: "Terms required",
            message: "You must accept the Terms & Conditions and Privacy Policy."
        });
        return;
    }

    if (!ValidateEmail(email)) {
        alertas({
            type: "error",
            title: "Error Email",
            message: "Invalid Format"
        });
        return;
    } else if (nombre.trim() === "") { // .trim() evita que manden solo espacios en blanco
        alertas({
            type: "error",
            title: "Error Name",
            message: "Invalid Format"
        });
        return;
    } else if (pass1 === "") {
        alertas({
            type: "error",
            title: "Error",
            message: "Put Password 1"
        });
        return;
    } else if (pass2 === "") {
        alertas({
            type: "error",
            title: "Error",
            message: "Put Password 2"
        });
        return;
    } else if (pass1 !== pass2) {
        alertas({
            type: "error",
            title: "Error",
            message: "Password_1 must be the same as Password_2"
        });
        return;
    }

    // Guardar en el store (Corrección de PASSWORD)
    store.GLOBAL_EMAIL = email;
    store.GLOBAL_NAME = nombre;
    store.GLOBAL_PASSWORD = pass1; // <-- Corregido el typo aquí

    // Proceder al registro
    register();
}





// =========================
// SLIDER IOS
// =========================

function view_slider() {

  const container = document.getElementById("sliderContainer");

  container.innerHTML = buildIosSliderHTML([

    {
      image: "https://cozumel-reef-maps.com.mx/Views/Default/img/test1.jpg",
      video: "https://youtube.com/shorts/4uyCZ_NQz6A"
    },

    {
      image: "https://cozumel-reef-maps.com.mx/Views/Default/img/test2.jpg",
      video: "https://youtube.com/shorts/ZQZuew6URrM"
    },

    {
      image: "https://cozumel-reef-maps.com.mx/Views/Default/img/test3.jpg",
      video: "https://youtube.com/shorts/XDZ2-F5lGHI"
    },

    {
      image: "https://cozumel-reef-maps.com.mx/Views/Default/img/test4.jpg",
      video: "https://youtube.com/shorts/KINncNwWYPY"
    }

  ]);

  initIosLightbox();
}


// =========================
// NEXT TICK (IMPORTANTE)
// =========================

function nextTick() {
  return new Promise(resolve => requestAnimationFrame(resolve));
}